import React from "react";
import PropTypes from "prop-types";

export default function CheckCircle(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check_circle_24px">
        <path
          id="icon/action/check_circle_24px"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.166656 16.0833C0.166656 7.29734 7.29733 0.166668 16.0833 0.166668C24.8693 0.166668 32 7.29734 32 16.0833C32 24.8693 24.8693 32 16.0833 32C7.29733 32 0.166656 24.8693 0.166656 16.0833ZM7.40872 16.9687L12.4254 21.9853C12.9704 22.5303 13.8647 22.5303 14.3957 21.9853L25.002 11.3791C25.547 10.8341 25.547 9.95373 25.002 9.40874C24.457 8.86375 23.5766 8.86375 23.0317 9.40874L13.4175 19.0229L9.37906 14.9983C8.83407 14.4534 7.95371 14.4534 7.40872 14.9983C7.14705 15.2594 7 15.6139 7 15.9835C7 16.3531 7.14705 16.7076 7.40872 16.9687Z"
          fill="#063AC9"
        />
      </g>
    </svg>
  );
}

CheckCircle.propTypes = {
  className: PropTypes.string,
  // fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
CheckCircle.defaultProps = {
  className: "",
  // fill: "#93ABCA",
  width: 15,
  height: 17
};
